import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { EnumFields } from 'types/enumerationData';
import { ServerMeta } from 'types/common';
import CommonStore from 'store/Common';
import useGetSettingData from 'hooks/useGetSettingData';

type StateSelectProps = {
    value?: string;
    onChange?: (val: string) => void;
    disableValues?: string[];
    hideValues?: string[];
    mode?: 'multiple' | '';
} & SelectProps;

const StateWithFeatureSelect = (props:StateSelectProps) => {
    const { onChange, disableValues, mode, hideValues, ...reset } = props;
    const [allItems] = useGetSettingData(EnumFields.STATE);

    const [allOption, setAllOption] = React.useState<ServerMeta[]>([]);
    const [featureOption, setFeatureOption] = React.useState<ServerMeta[]>([]);

    const [getCommon] = CommonStore.useStore();
    const featureStateFromStore = getCommon('featuredState');

    const disabledLength = disableValues?.length || 0;
    const hideLength = hideValues?.length || 0;
    React.useEffect(() => {
        if (featureStateFromStore) {
            setFeatureOption((featureStateFromStore as ServerMeta[]).filter((state:ServerMeta) => !hideValues?.includes(state.content) && !hideValues?.includes(state.dictKey as string)));
        }
        if (allItems) {
            setAllOption((allItems as ServerMeta[]).filter((state:ServerMeta) => !hideValues?.includes(state.content) && !hideValues?.includes(state.dictKey as string)));
        }

        //const _otherStates: Meta[] = stateOption.filter((state:Meta) => !featureStatesKey.includes(state.value as string) && !featureStatesKey.includes(state.label as string));
        //setOtherStates(_otherStates);
    }, [allItems, featureStateFromStore, disabledLength, hideLength, hideValues]);

    return (
        <Select
            {...reset}
            onChange={onChange}
            showSearch
            virtual={false}
            mode={mode}
            options={[
                {
                    label: <span>Top states</span>,
                    title: 'Top states',
                    options: featureOption.map((item) => {
                        if (disableValues?.includes(item.dictKey) || disableValues?.includes(item.content as string)) {
                            return {
                                label: item.content,
                                value: item.dictKey,
                                disabled: true,
                                key: `feature${item.content}`,
                            };
                        }
                        return {
                            label: item.content,
                            value: item.dictKey,
                            key: `feature${item.content}`,
                        };
                    }),
                },
                {
                    label: <span>All states</span>,
                    title: 'All states',
                    options: allOption.map((item) => {
                        if (disableValues?.includes(item.dictKey) || disableValues?.includes(item.content as string)) {
                            return {
                                label: item.content,
                                value: item.dictKey,
                                disabled: true,
                            };
                        }
                        return {
                            label: item.content,
                            value: item.dictKey,
                        };
                    }),
                },
            ]}
        />
    );
};

export default StateWithFeatureSelect;
